import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "breadcrumbs", "id", "title", "subtitle", "banner", "thumbnail", "thumbnailFallback", "thumbnailAction", "metadata", "description", "controls", "status", "availableSpace", "isFullWidth", "primaryAction", "secondaryActions", "isNarrowWidth", "shouldGroupActions", "children", "slots"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Menu from '../Menu';
import Button from '../Button';
import Chip from '../Chip';
import Link from '../Link';
import { StyledPage, StyledPageTop, StyledPageBottom, StyledPageBreadcrumb, StyledPageHeader, StyledPageHeaderContainer, StyledPageHeaderContent, StyledPageHeaderTitles, StyledPageHeaderActions, StyledPageHeaderControls, StyledPageHeaderAligner, StyledPageMetadata, StyledPageTitle, StyledPageSubtitle, StyledPageTitleContainer, StyledPageAvailableSpace, StyledPageDescription, StyledPageContent, StyledPageStatus, StyledPageThumbnailContainer, StyledPageThumbnail, StyledPageThumbnailAction, StyledPageThumbnailImage, StyledPageDivider, StyledPageSlots, StyledPageBanner } from './Page.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Page = forwardRef(function (_ref, ref) {
  var _cx, _primaryAction$varian;

  var customClassName = _ref.className,
      breadcrumbs = _ref.breadcrumbs,
      id = _ref.id,
      title = _ref.title,
      subtitle = _ref.subtitle,
      banner = _ref.banner,
      thumbnail = _ref.thumbnail,
      thumbnailFallback = _ref.thumbnailFallback,
      thumbnailAction = _ref.thumbnailAction,
      metadata = _ref.metadata,
      description = _ref.description,
      controls = _ref.controls,
      status = _ref.status,
      availableSpace = _ref.availableSpace,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      primaryAction = _ref.primaryAction,
      secondaryActions = _ref.secondaryActions,
      isNarrowWidth = _ref.isNarrowWidth,
      _ref$shouldGroupActio = _ref.shouldGroupActions,
      shouldGroupActions = _ref$shouldGroupActio === void 0 ? false : _ref$shouldGroupActio,
      children = _ref.children,
      slots = _ref.slots,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-page"), true), _defineProperty(_cx, "".concat(prefix, "-page--banner"), banner), _defineProperty(_cx, "".concat(prefix, "-page--fullwidth"), isFullWidth), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  function renderPageStatus() {
    var isArr = Array.isArray(status);
    var isStr = typeof status === 'string';

    if (isStr) {
      return _jsx(StyledPageStatus, {
        className: "".concat(prefix, "-page__status"),
        children: _jsx(Chip, {
          variant: "status",
          mode: "grey",
          children: status
        })
      });
    } else {
      var statusArr = isArr ? _toConsumableArray(status) : [status];
      return _jsx(StyledPageStatus, {
        className: "".concat(prefix, "-page__status"),
        children: statusArr.map(function (chip, index) {
          return _jsx(Chip, {
            variant: "status",
            mode: "grey",
            status: chip.type,
            hasStatusLight: chip.hasStatusLight,
            children: chip.label
          }, index);
        })
      });
    }
  }

  function renderPageHeaderTitles() {
    return _jsxs(_Fragment, {
      children: [metadata && _jsx(StyledPageMetadata, {
        className: "".concat(prefix, "-page__metadata"),
        children: metadata
      }), _jsx(StyledPageTitleContainer, {
        children: title && _jsxs(StyledPageTitle, {
          className: "".concat(prefix, "-page__title"),
          children: [title, subtitle && _jsx(StyledPageSubtitle, {
            className: "".concat(prefix, "-page__subtitle"),
            children: subtitle
          }), status && renderPageStatus()]
        })
      }), availableSpace && _jsx(StyledPageAvailableSpace, {
        className: "".concat(prefix, "-page__available-space"),
        children: availableSpace
      }), description && _jsx(StyledPageDescription, {
        className: "".concat(prefix, "-page__description"),
        children: description
      }), controls && _jsx(StyledPageHeaderControls, {
        className: "".concat(prefix, "-page__controls"),
        children: controls
      })]
    });
  }

  return _jsxs(StyledPage, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: [banner && _jsx(StyledPageBanner, {
      className: "".concat(prefix, "-page__banner"),
      src: banner
    }), _jsx(StyledPageTop, {
      children: _jsxs(StyledPageHeader, {
        className: "".concat(prefix, "-page__header"),
        children: [_jsxs(StyledPageHeaderContainer, {
          children: [breadcrumbs && _jsx(StyledPageBreadcrumb, {
            className: "".concat(prefix, "-page__breadcrumb"),
            children: breadcrumbs.map(function (item, i) {
              return i === 0 ? _jsx(Link, {
                as: item.as,
                to: item.url,
                exact: item.exact || item.isExact,
                iconLeft: "chevron-left",
                href: item.url,
                isDisabled: item.disabled || item.isDisabled,
                onClick: item.action || item.onClick,
                children: item.content
              }, i) : _jsx(Link, {
                as: item.as,
                to: item.url,
                exact: item.exact || item.isExact,
                href: item.url,
                isDisabled: item.disabled || item.isDisabled,
                onClick: item.action || item.onClick,
                children: item.content
              }, i);
            })
          }), _jsxs(StyledPageHeaderContent, {
            children: [thumbnail && _jsxs(StyledPageThumbnailContainer, {
              children: [_jsx(StyledPageThumbnail, {
                children: _jsx(StyledPageThumbnailImage, {
                  src: thumbnail,
                  fallbackSrc: thumbnailFallback,
                  alt: "Thumbnail"
                })
              }), thumbnailAction && _jsx(StyledPageThumbnailAction, {
                variant: "tertiary",
                icon: thumbnailAction.icon,
                onClick: thumbnailAction.onClick,
                isDisabled: thumbnailAction.isDisabled,
                size: "small"
              })]
            }), _jsx(StyledPageHeaderTitles, {
              children: thumbnail ? _jsx(StyledPageHeaderAligner, {
                children: renderPageHeaderTitles()
              }) : renderPageHeaderTitles()
            })]
          })]
        }), _jsxs(StyledPageHeaderActions, {
          children: [secondaryActions && !shouldGroupActions && secondaryActions.length === 1 && secondaryActions.map(function (item, i) {
            var _item$variant;

            return _jsx(Button, {
              variant: (_item$variant = item.variant) !== null && _item$variant !== void 0 ? _item$variant : 'secondary',
              isDisabled: item.isDisabled,
              isLoading: item.isLoading,
              iconLeft: item.icon,
              onClick: item.action || item.onClick,
              style: {
                marginRight: '8px'
              },
              children: item.content
            }, i);
          }), primaryAction && _jsx(Button, {
            variant: (_primaryAction$varian = primaryAction.variant) !== null && _primaryAction$varian !== void 0 ? _primaryAction$varian : 'primary',
            iconLeft: primaryAction.icon,
            isDisabled: primaryAction.disabled || primaryAction.isDisabled,
            isLoading: primaryAction.loading || primaryAction.isLoading,
            onClick: primaryAction.action || primaryAction.onClick,
            className: "".concat(prefix, "-page__primary-action"),
            children: primaryAction.content
          }), (secondaryActions && secondaryActions.length > 1 || secondaryActions && shouldGroupActions) && _jsxs(Menu, {
            className: "".concat(prefix, "-page__secondary-action"),
            children: [_jsx(Menu.Button, {
              variant: shouldGroupActions ? 'tertiary' : 'secondary',
              size: "medium",
              style: {
                marginLeft: '8px'
              }
            }), _jsx(Menu.List, {
              children: secondaryActions.map(function (item, i) {
                return item.isDivider ? _jsx(Menu.Divider, {}) : _jsx(Menu.Item, {
                  isDisabled: item.isDisabled,
                  icon: item.icon,
                  isNew: item.isNew,
                  onClick: item.action || item.onClick,
                  children: item.content
                }, i);
              })
            })]
          })]
        })]
      })
    }), controls && _jsx(StyledPageDivider, {
      className: "".concat(prefix, "-page__divider")
    }), slots && _jsx(StyledPageSlots, {}), _jsx(StyledPageBottom, {
      children: _jsx(StyledPageContent, {
        className: "".concat(prefix, "-page__content"),
        children: children
      })
    })]
  }));
});
export default Page;